import * as React from 'react'
import { Box, Button, TextField, Paper, MenuItem, Switch, FormControlLabel, Typography, CircularProgress, debounce, makeStyles, Dialog, DialogTitle, DialogContent, IconButton, LinearProgress, DialogActions } from '@material-ui/core'
import { useDropzone } from 'react-dropzone'
import { cos } from '../../utils/cos'
import BraftEditor, { EditorState } from 'braft-editor'
import 'braft-editor/dist/index.css'
import Select from 'react-select'
import { useQuery } from 'react-query'
import { listTag, addTag, saveCourse, getCourse, getCourseCollection, VodAPI } from '../../utils/api'
import { CoursePriceLevels } from '../../constants'
import CoursePreview from '../../components/CoursePreview'
import { useFeedback } from '../../components/Feedback'
import { useParams, useHistory } from 'react-router'
import ClearIcon from '@material-ui/icons/Clear';
import { DateTimePicker } from '@material-ui/pickers'
import moment from 'moment'
import TcVod from 'vod-js-sdk-v6'
const updateDetails = debounce((success) => {
    success()
}, 1000)

const useStyles = makeStyles({
    sel: {
        zIndex: 10
    }
})

const AddCourse = () => {
    const classes = useStyles()
    const { showToast } = useFeedback()
    const history = useHistory()
    const [showUpload, setShowUpload] = React.useState(false)
    const [uploadVideo, setUploadVideo] = React.useState<File | undefined>()
    const [uploadFaild, setUploadFaild] = React.useState('')
    const [uploadImg, setUploadImg] = React.useState(false)
    const { data: collections } = useQuery<CourseCollection[]>('getCourseCollection', () => getCourseCollection())
    const [uploadProgress, setUploadProgress] = React.useState({
        loaded: 0,
        total: 0,
        speed: 0,
        percent: 0
    })
    const { courseId }: { courseId: string } = useParams()
    const { data: tags, refetch: refetchTags } = useQuery<Tag[]>('listtag', () => listTag())
    const [editorState, setEditorState] = React.useState(BraftEditor.createEditorState(null))
    const [course, setCourse] = React.useState<Course>({
        id: '',
        name: '',
        vip_free: 0,
        type: 'pay',
        category: '',
        iap_id: '',
        tags: []
    })
    const [tagIds, setTagIds] = React.useState<{ value: string }[]>([])
    const { acceptedFiles, getRootProps, getInputProps } = useDropzone()
    const { acceptedFiles: acceptedVideoFiles, getRootProps: getVideoRootProps, getInputProps: getVideoInputProps } = useDropzone()
    const [freeBeginTime, setFreeBeginTime] = React.useState<Date | null>(null)
    const [freeEndTime, setFreeEndTime] = React.useState<Date | null>(null)
    const getSignature = () => {
        return VodAPI.getSignature().then(res => {
            return res.data.signature
        })
    }
    const tcvod = new TcVod({
        getSignature: getSignature
    })

    const handleUpload = (files: File[]) => {
        if (!files || files.length < 1) {
            return;
        }
        const file = files[files.length - 1]
        const filename = Date.now() + file.name.substr(file.name.lastIndexOf('.'))
        setUploadImg(true)
        cos.sliceUploadFile({
            Bucket: 'video-1302643710', /* 必须 */
            Key: 'img/cover/' + filename,              /* 必须 */
            Body: file,
            Region: 'ap-beijing',
            onTaskReady: function (taskId: any) {                   /* 非必须 */
                console.log(taskId);
            },
            onHashProgress: function (progressData: any) {       /* 非必须 */
                console.log(JSON.stringify(progressData));
            },
            onProgress: function (progressData: any) {           /* 非必须 */
                console.log(JSON.stringify(progressData));
            }
        }, (err: any, data: any) => {
            console.log(err || data);
            setUploadImg(false)
            if (!err) {
                setCourse({ ...course, cover: `https://res.add-coach.com/${data.Key}` })
            } else {
                showToast('封面图上传失败，请重试')
            }
        })
    }

    const handleUploadToVod = (id: string) => {
        if (!uploadVideo) {
            return;
        }

        const filename = Date.now() + uploadVideo.name.substr(uploadVideo.name.lastIndexOf('.'))

        const uploader = tcvod.upload({
            mediaFile: uploadVideo,
            mediaName: filename,
        })

        uploader.on('media_upload', (info) => {
            console.log('media upload', info)
        })

        uploader.on('media_progress', (info) => {
            console.log("media progress", JSON.stringify(info));
            setUploadProgress(info)
        })

        uploader.done().then(res => {
            console.log('uploader done', res)
            setUploadVideo(undefined)
            const tids = tagIds.map(t => t.value)
            const url = res.video.url
            saveCourse({ ...course, vod_id: res.fileId, id: id, url: res.video.url }, tids).then(res => {
                const { id: cid } = res.data
                setCourse({ ...course, id: cid, url: url })
                showToast('提交成功')
            }).catch(e => {
                console.error(e)
                showToast('提交失败')
            })
        })
    }

    const handleUploadVideo = (id: string) => {
        if (!uploadVideo) {
            return;
        }
        setUploadFaild('')
        const filename = Date.now() + uploadVideo.name.substr(uploadVideo.name.lastIndexOf('.'))
        cos.sliceUploadFile({
            Bucket: 'video-1302643710', /* 必须 */
            Key: 'video/' + id + '/' + filename,              /* 必须 */
            Body: uploadVideo,
            Region: 'ap-beijing',
            onTaskReady: function (taskId: any) {                   /* 非必须 */
                console.log(taskId);
            },
            onHashProgress: function (progressData: any) {       /* 非必须 */
                console.log(JSON.stringify(progressData));
                setUploadProgress(progressData)
            },
            onProgress: function (progressData: any) {           /* 非必须 */
                console.log(JSON.stringify(progressData));
                setUploadProgress(progressData)
            }
        }, (err: any, data: any) => {
            console.log(err || data);
            if (!err) {
                setUploadVideo(undefined)
                const tids = tagIds.map(t => t.value)
                saveCourse({ ...course, id: id, url: `https://res.add-coach.com/${data.Key}` }, tids).then(res => {
                    const { id: cid } = res.data
                    console.error(cid)
                    setCourse({ ...course, id: cid, url: `https://res.add-coach.com/${data.Key}` })
                    showToast('提交成功')
                }).catch(e => {
                    showToast('提交失败')
                })
            } else {
                showToast('上传失败')
                setUploadFaild('上传失败，点击重试按钮重新上传')
            }
        })
    }

    React.useEffect(() => {
        const file = acceptedVideoFiles[acceptedVideoFiles.length - 1]
        setUploadVideo(file)
        if (file) {
            const video = document.createElement('video')
            video.preload = 'metadata'
            video.onloadedmetadata = () => {
                window.URL.revokeObjectURL(video.src);
                var duration = video.duration;
                setCourse({ ...course, duration: Math.floor(duration) })
            }
            video.src = URL.createObjectURL(file);;
        }
    }, [acceptedVideoFiles])

    React.useEffect(() => {
        handleUpload(acceptedFiles)
    }, [acceptedFiles])

    React.useEffect(() => {
        if (courseId) {
            loadCourse(courseId)
        }
    }, [])

    const loadCourse = (id: string) => {
        getCourse(id).then(res => {
            setCourse(res.data)
            if (res.data.details_raw) {
                setEditorState(BraftEditor.createEditorState(res.data.details_raw))
            } else if (res.data.details) {
                setEditorState(BraftEditor.createEditorState(res.data.details))
            }
            if (res.data.free_begin_time) {
                setFreeBeginTime(moment(res.data.free_begin_time).toDate())
            }
            if (res.data.free_end_time) {
                setFreeEndTime(moment(res.data.free_end_time).toDate())
            }
            setTagIds(defaultTagsOptions(res.data.tags))
        })
    }

    const hanldeEditorChange = (state: EditorState) => {
        updateDetails(() => {
            setCourse({ ...course, details: state.toHTML() })
        })
        setEditorState(state)
    }

    const tagsOptions = () => {
        let options = tags?.map(v => {
            return {
                value: v.id,
                label: v.name
            }
        })
        return options;
    }

    const defaultTagsOptions = (tags: Tag[]) => {
        let options = tags.map(v => {
            return {
                value: v.id,
                label: v.name
            }
        })
        return options;
    }

    const handleAddTag = (name: string) => () => {
        addTag(name).then(res => {
            refetchTags()
        })
    }

    const noMatch: any = (event: { inputValue: string }) => {
        return (
            <div>
                {event.inputValue && <Button onClick={handleAddTag(event.inputValue)} >创建"{event.inputValue}"标签</Button>}
            </div>
        )
    }

    const handleEditorUpload = (param: {
        file: File, success: (res: {
            url: string, meta: {
                id: string
                title: string
                alt: string
                loop: boolean
                autoPlay: boolean
                controls: boolean
                poster: string
            }
        }) => void
    }) => {
        const file = param.file
        const filename = Date.now() + file.name.substr(file.name.lastIndexOf('.'))

        cos.sliceUploadFile({
            Bucket: 'video-1302643710', /* 必须 */
            Key: 'img/course_detail/' + filename,              /* 必须 */
            Body: file,
            Region: 'ap-beijing',
            onTaskReady: function (taskId: any) {                   /* 非必须 */
                console.log(taskId);
            },
            onHashProgress: function (progressData: any) {       /* 非必须 */
                console.log(JSON.stringify(progressData));
            },
            onProgress: function (progressData: any) {           /* 非必须 */
                console.log(JSON.stringify(progressData));
            }
        }, (err: any, data: any) => {
            if (!err) {
                const url = 'https://res.add-coach.com/' + data.Key
                param.success({
                    url: url, meta: {
                        id: '',
                        title: '',
                        controls: false,
                        autoPlay: false,
                        loop: false,
                        alt: '',
                        poster: ''
                    }
                })
            }
            console.log(err || data);
        })
    }

    const handleCourseChange = (key: string) => (event: React.ChangeEvent<HTMLInputElement>, checked?: boolean) => {
        if (key === 'iap_id') {
            const [price] = CoursePriceLevels.filter(p => p.iap_id === event.target.value)
            setCourse({ ...course, iap_id: price.iap_id, price: price.price })
        } else if (key === 'vip_free') {
            setCourse({ ...course, vip_free: event.target.checked ? 1 : 0 })
        } else if (key === 'type') {
            setCourse({ ...course, type: event.target.checked ? 'free' : 'pay' })
        } else {
            setCourse({ ...course, [key]: event.target.value })
        }
    }

    const handleTagChange = (value: any) => {
        setTagIds(value)
    }

    const handleSave = () => {
        if (!course.name) {
            showToast('请输入课程名称')
            return;
        }
        if (!course.cover) {
            showToast('请上传课程封面图')
            return;
        }
        if (!course.category) {
            showToast('请选择课程分类')
            return;
        }
        if (!course.price) {
            showToast('请输入课程定价')
            return;
        }
        if (freeBeginTime && !freeEndTime) {
            showToast('请输入免费结束时间');
            return;
        }
        if (!freeBeginTime && freeEndTime) {
            showToast('请输入免费开始时间');
            return;
        }
        if (freeBeginTime && freeEndTime && moment(freeBeginTime).isAfter(freeEndTime)) {
            showToast('免费结束时间不能在开始时间之前，请重新输入')
            return;
        }
        if (freeBeginTime) {
            course.free_begin_time = freeBeginTime.getTime()
        } else {
            course.free_begin_time = null
        }
        if (freeEndTime) {
            course.free_end_time = freeEndTime.getTime()
        } else {
            course.free_end_time = null
        }
        course.details = editorState.toHTML();
        course.details_raw = editorState.toRAW();
        const tids = tagIds.map(t => t.value)

        saveCourse(course, tids).then(res => {
            const { id } = res.data
            console.error(id)
            setCourse({ ...course, id })
            if (uploadVideo) {
                // handleUploadVideo(id)
                handleUploadToVod(id)
                setShowUpload(true)
            } else {
                showToast('提交成功')
            }
        }).catch(e => {
            showToast('保存失败')
        })
    }

    const handleUploadClose = () => {
        if (!courseId) {
            history.replace(`/admin/course/edit/${course.id}`)
        }
        setShowUpload(false)
    }

    const formatFlow = (input: number) => {
        const K = 1000;

        const M = 1024 * 1024;
        const G = 1024 * 1024 * 1024;
        const T = 1024 * 1024 * 1024 * 1024;
        const P = 1024 * 1024 * 1024 * 1024 * 1024;
        if (input < K) {
            return input + 'B';
        } else if (input < M) {
            return (input / K).toFixed(1) + 'KB';
        } else if (input < G) {
            return (input / M).toFixed(1) + 'MB';
        } else if (input < T) {
            return (input / G).toFixed(1) + 'GB';
        } else if (input < P) {
            return (input / T).toFixed(1) + 'TB';
        } else {
            return input;
        }
    }

    return <Box>
        <Paper>
            <Box display="flex">
                <Box flexGrow="1" p={2}>
                    <Box display="flex" justifyContent="space-between">
                        <Box></Box>
                        <Button onClick={handleSave}>提交</Button>
                    </Box>
                    <Box mt={2}>
                        <TextField variant="outlined" size="small" label="课程名称" value={course.name} onChange={handleCourseChange('name')} fullWidth />
                    </Box>
                    <Box mt={2} display="flex">
                        <Box>
                            <Typography>封面图</Typography>
                            <Box width="125px" height="93px" mt={1} position="relative">
                                <div {...getRootProps({ className: 'dropzone' })} style={{ minHeight: '93px', border: '1px dashed #e1e1e1', borderRadius: '4px' }}>
                                    <input {...getInputProps()} />
                                    <Typography variant="caption" align="center">点击或拖拽封面图至此</Typography>
                                </div>
                                {course.cover && <img src={course.cover} style={{ position: 'absolute', top: '0', left: '0', pointerEvents: 'none', cursor: 'pointer', width: '100%', height: '100%' }} />}
                                {uploadImg && <Box display="flex" alignItems="center" justifyContent="center" style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}>
                                    <CircularProgress size={24} />
                                </Box>}
                            </Box>
                        </Box>
                        <Box ml={6} display="flex">
                            <Box>
                                <Typography>视频</Typography>
                                <Box width="125px" height="93px" mt={1} position="relative">
                                    <div {...getVideoRootProps({ className: 'dropzone' })} style={{ minHeight: '93px', border: '1px dashed #e1e1e1', borderRadius: '4px' }}>
                                        <input {...getVideoInputProps()} />
                                        <Typography variant="caption" align="center">点击或拖拽封视频至此</Typography>
                                    </div>
                                    {course.url && <video src={course.url} style={{ position: 'absolute', top: '0', left: '0', pointerEvents: 'none', width: '100%', height: '100%' }} />}
                                </Box>
                            </Box>
                            <Box ml={2}>
                                <Typography>&nbsp;</Typography>
                                {uploadVideo && <React.Fragment>
                                    <Typography variant="subtitle2">等待上传</Typography>
                                    <Typography variant="body2">{uploadVideo && uploadVideo.name} <IconButton size="small" onClick={
                                        () => setUploadVideo(undefined)
                                    }><ClearIcon /></IconButton></Typography>
                                </React.Fragment>}
                            </Box>
                        </Box>
                    </Box>
                    <Box mt={3}>
                        <TextField value={course.category ? `${course.category}` : ''} onChange={handleCourseChange('category')} variant="outlined" size="small" label="课程分类" select style={{ width: '160px' }}>
                            <MenuItem value="2">直播回看</MenuItem>
                            <MenuItem value="1">精品课</MenuItem>
                            <MenuItem value="3">大师课</MenuItem>
                        </TextField>
                        <TextField select label="所属合辑" value={course.collection_id ? `${course.collection_id}` : '0'} onChange={handleCourseChange('collection_id')} variant="outlined" size="small" style={{ width: '200px', marginLeft: '24px' }}>
                            <MenuItem value="0">无</MenuItem>
                            {collections?.map(c => <MenuItem key={c.id} value={`${c.id}`}>{c.name}</MenuItem>)}
                        </TextField>
                    </Box>
                    <Box mt={2} >
                        <Select className={classes.sel} placeholder="课程标签" value={tagIds} onChange={handleTagChange} isMulti options={tagsOptions()} noOptionsMessage={noMatch}>
                        </Select>
                    </Box>
                    <Box display="flex" alignItems="flex-end" mt={2}>
                        <TextField value={course.price ? `${course.price}` : ''} variant="outlined" size="small" onChange={handleCourseChange('price')} label="课程定价" />
                        <TextField style={{ marginLeft: '10px' }} value={course.original_price ? `${course.original_price}` : ''} variant="outlined" size="small" onChange={handleCourseChange('original_price')} label="课程原价" />


                    </Box>
                    <Box display="flex" mt={2} alignItems="center">
                        <FormControlLabel
                            control={<Switch checked={!!course.vip_free} color="primary" onChange={handleCourseChange('vip_free')} />}
                            label="VIP会员免费看"
                            labelPlacement="start"
                        />
                        <FormControlLabel
                            control={<Switch checked={course.type === 'free'} onChange={handleCourseChange('type')} color="primary" />}
                            label="限时免费"
                            labelPlacement="start"
                        />
                        {course.type === 'free' && <Box ml={2}>
                            <DateTimePicker
                                label="开始时间"
                                inputVariant="outlined"
                                size="small"
                                clearable
                                minDate={new Date()}
                                value={freeBeginTime}
                                format="yyyy-MM-dd HH:mm"
                                onChange={(date: Date | null) => setFreeBeginTime(date)}
                            />
                            <DateTimePicker
                                style={{ marginLeft: '16px' }}
                                label="结束时间"
                                inputVariant="outlined"
                                size="small"
                                clearable
                                minDate={freeBeginTime}
                                value={freeEndTime}
                                format="yyyy-MM-dd HH:mm"
                                onChange={(date: Date | null) => setFreeEndTime(date)}
                            />
                            <Typography variant="caption" color="primary" style={{ marginLeft: '8px' }}>
                                如果不选择限时免费开始和结束时间,课程将长期限时免费
                            </Typography>
                        </Box>}
                    </Box>
                    <Box mt={2}>
                        <Typography>课程详情</Typography>
                    </Box>
                    <Box border="1px solid #e1e1e1" borderRadius={4} mt={1}>
                        <BraftEditor media={{ uploadFn: handleEditorUpload }} value={editorState} onChange={hanldeEditorChange} />
                    </Box>
                </Box>
                <Box flexShrink="0">
                    <CoursePreview course={course} />
                </Box>
            </Box>
        </Paper>

        <Dialog open={showUpload} maxWidth="lg" >
            <DialogTitle>正在上传视频,请勿关闭或刷新当前窗口</DialogTitle>
            <DialogContent style={{ width: '600px' }}>
                <Box>
                    <Typography variant="body2">{uploadVideo?.name}</Typography>
                    <Typography variant="caption" style={{ color: '#d14' }}>{uploadFaild}</Typography>
                    <Typography variant="caption">{uploadProgress.percent === 1 ? '上传成功' : ''}</Typography>
                </Box>
                <Box mt={2} display="flex" justifyContent="space-between">
                    <Box display="flex">
                        <Typography variant="caption">正在上传</Typography>
                        <Typography variant="caption">{`(${formatFlow(uploadProgress.loaded)}/${formatFlow(uploadProgress.total)}) 速度${formatFlow(uploadProgress.speed)}`}</Typography>
                    </Box>
                    <Box>
                        <Typography variant="caption">
                            {Math.floor(uploadProgress.percent * 100)}%
                        </Typography>
                    </Box>
                </Box>
                <LinearProgress value={uploadProgress.percent * 100} variant="determinate" />
            </DialogContent>
            <DialogActions>
                {uploadProgress.percent === 1 && <Button onClick={handleUploadClose}>关闭</Button>}
                {uploadFaild && <Button onClick={() => handleUploadToVod(course.id + '')}>重试</Button>}
            </DialogActions>
        </Dialog>
    </Box>
}

export default AddCourse